import axiosInstance from './axiosInstance'
import type { UserAchievement } from '../models/UserAchievement'

export const getAchievementsByUser = async (userId: string): Promise<UserAchievement[]> => {
  const res = await axiosInstance.get(`/achievements/user/${userId}`)
  return res.data
}